import { API_BASE_URL } from '@/shared/config';
import { request, setCsrfToken } from '@/shared/api';
export function loginUrl(returnTo = window.location.origin) {
    const encoded = encodeURIComponent(returnTo);
    return `${API_BASE_URL}/api/v1/auth/login?returnTo=${encoded}`;
}
export async function me() {
    const user = await request('/api/v1/auth/me');
    setCsrfToken(user.csrfToken);
    return user;
}
export async function logout() {
    const result = await request('/api/v1/auth/logout', {
        method: 'POST',
    });
    setCsrfToken(null);
    return result;
}
